/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

class Throbber extends React.Component {
	static propTypes = {
		show: PropTypes.bool,
	}

	state = {
		show: this.props.show,
	};

	componentWillReceiveProps(nextProps) {
		return this.setState({
			show: nextProps.show,
		});
	}

	render() {
		const cdn = "//cdn.okccdn.com";
		const img = `${cdn}/media/img/throbbers/throbber-sm.gif`;
		const classes = classnames({
			loader: true,
			show: this.state.show,
		});

		return <img alt="loader" className={classes} src={img} />;
	}
}

export default Throbber;



// WEBPACK FOOTER //
// ./src/shared/components/Throbber.jsx